var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 4.33333L11.375 1.625M11.375 1.625H8.66667M11.375 1.625V4.33333M4.33333 4.33333L1.625 1.625M1.625 1.625L1.625 4.33333M1.625 1.625L4.33333 1.625M4.33333 8.66667L1.625 11.375M1.625 11.375H4.33333M1.625 11.375L1.625 8.66667M8.66667 8.66667L11.375 11.375M11.375 11.375V8.66667M11.375 11.375H8.66667",
    stroke: "#808795",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenIcon);
export default __webpack_public_path__ + "static/media/open-icon.8faa445d6e0a31c8a068ebabd76defca.svg";
export { ForwardRef as ReactComponent };